export default {
	name: "ButtonBlock",
	data() {
		return {
			isHover: false,
		}
	},
	props: [
		"title",
		"subTitle",
		"link",
		"dropdown",
	],
	created() {},
	watch: {},
	computed: {},
	methods: {
		showDropdown() {
			this.isHover = true;
		},
		hideDropdown() {
			this.isHover = false;
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/button-block/button.block.js